import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/system'
import CheckmarkCircleIcon from '../../../atoms/icons/checkmark-icon'
import BHPrice from '../../../molecules/price'

const ProductsWrapper = styled(Grid)`
	padding-top: ${({ theme }) => theme.spacing(4)} !important;
	position: relative;
`

const Price = styled(BHPrice)`
	display: inline-block;
`

const FreeShippingReached = styled(Typography)`
	color: #75a753;
`

const FreeShippingNeeded = styled(Typography)`
	color: #75a753;
`

const CheckmarkCircleIconStyled = styled(CheckmarkCircleIcon)`
	font-size: ${({ theme }) => theme.typography.pxToRem(20)};
	margin-right: ${({ theme }) => theme.spacing(1.5)};
	position: relative;
	top: ${({ theme }) => theme.spacing(0.5)};
`

export { CheckmarkCircleIconStyled, FreeShippingReached, FreeShippingNeeded, Price, ProductsWrapper }
